export var selectCsoundStatus = function selectCsoundStatus(store) {
    var state = store.csound;
    return state.status;
};
